import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 1.16667V0.583333C10.5 0.261333 10.2392 0 9.91667 0C9.59408 0 9.33333 0.261333 9.33333 0.583333V1.16667H4.66667V0.583333C4.66667 0.261333 4.40533 0 4.08333 0C3.76133 0 3.5 0.261333 3.5 0.583333V1.16667C1.56975 1.16667 0 2.73642 0 4.66667V10.5C0 12.4302 1.56975 14 3.5 14H10.5C12.4302 14 14 12.4302 14 10.5V4.66667C14 2.73642 12.4302 1.16667 10.5 1.16667ZM3.5 2.33333H10.5C11.7868 2.33333 12.8333 3.37983 12.8333 4.66667H1.16667C1.16667 3.37983 2.21317 2.33333 3.5 2.33333ZM10.5 12.8333H3.5C2.21317 12.8333 1.16667 11.7868 1.16667 10.5V5.83333H12.8333V10.5C12.8333 11.7868 11.7868 12.8333 10.5 12.8333ZM4.08333 8.16667C4.08333 7.84408 4.34467 7.58333 4.66667 7.58333H7.92517L7.75425 7.41242C7.52617 7.18433 7.52617 6.81567 7.75425 6.58758C7.98233 6.3595 8.351 6.3595 8.57908 6.58758L9.74575 7.75425C9.91258 7.92108 9.96275 8.17192 9.87233 8.39008C9.7825 8.60825 9.569 8.75 9.33333 8.75H4.66667C4.34467 8.75 4.08333 8.48925 4.08333 8.16667ZM9.91667 10.5C9.91667 10.8226 9.65592 11.0833 9.33333 11.0833H6.07483L6.24575 11.2542C6.47383 11.4823 6.47383 11.851 6.24575 12.0791C6.132 12.1928 5.98267 12.25 5.83333 12.25C5.684 12.25 5.53467 12.1928 5.42092 12.0791L4.25425 10.9124C4.08742 10.7456 4.03725 10.4948 4.12767 10.2766C4.21808 10.0584 4.431 9.91667 4.66667 9.91667H9.33333C9.65592 9.91667 9.91667 10.1774 9.91667 10.5Z"
      fill="#151718"
    />
  </svg>
);

const RescheduleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default RescheduleIcon;
